<template>
    <div class="pa-3 d-flex justify-space-between align-center">
        <small>({{count}}) Components</small>
        <v-spacer/>
        <v-btn size="small" variant="text" @click="$emit('onRemove')">Remove all</v-btn>
    </div>
</template>

<script>
export default {
    props: ['count']
}
</script>
